import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

/**
 * Desktop navigation with dropdown menus.
 * Now uses navy text on white header background.
 * "Join Our Team" styled as secondary link.
 * Responsive padding for different desktop widths.
 */
const DesktopNav = ({ navigation, activeDropdown, setActiveDropdown }) => {
  return (
    <nav className="hidden lg:flex items-center">
      {navigation.map((item) => {
        // Make "Join Our Team" secondary/understated
        const isSecondary = item.name === 'Join Our Team';
        
        return (
          <div
            key={item.name}
            className="relative"
            onMouseEnter={() => item.dropdown && setActiveDropdown(item.name)}
            onMouseLeave={() => setActiveDropdown(null)}
          >
            {item.dropdown ? (
              <button 
                className={`flex items-center gap-0.5 px-2 xl:px-3 py-2 text-[13px] xl:text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                  isSecondary
                    ? 'text-brand-slate hover:text-brand-navy'
                    : 'text-brand-navy hover:text-brand-yellow hover:bg-brand-grey/50'
                }`}
              >
                {item.name}
                <ChevronDown className={`w-3 h-3 xl:w-3.5 xl:h-3.5 transition-transform ${activeDropdown === item.name ? 'rotate-180' : ''}`} />
              </button>
            ) : (
              <Link
                to={item.href}
                className={`px-2 xl:px-3 py-2 text-[13px] xl:text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                  isSecondary
                    ? 'text-brand-slate hover:text-brand-navy'
                    : 'text-brand-navy hover:text-brand-yellow hover:bg-brand-grey/50'
                }`}
              >
                {item.name}
              </Link>
            )}
            
            {/* Dropdown Menu */}
            {item.dropdown && activeDropdown === item.name && (
              <div className="absolute left-0 top-full pt-2 z-50">
                <div className="bg-white rounded-xl shadow-xl border border-slate-200 py-2 min-w-[200px]">
                  {item.dropdown.map((subItem) => (
                    <Link
                      key={subItem.name}
                      to={subItem.href}
                      className="block px-4 py-2.5 text-sm text-brand-slate hover:bg-brand-grey hover:text-brand-navy transition-colors"
                      onClick={() => setActiveDropdown(null)}
                    >
                      {subItem.name}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default DesktopNav;
